import { Box, Divider, Text } from '@chakra-ui/react';
import WarningTagComp from './WarningTagComp';

export const CardDetail = ({
    title = 'Title',
    children,
    isWarning = false,
    isLoading = false,
    warningLabel = 'Label',
    ...props
}) => {
    return (
        <Box
            p={'24px'}
            bg={'semantic.100'}
            border={'1px solid'}
            borderColor={'neutral.200'}
            borderRadius={'8px'}
            {...props}
        >
            {isLoading ? (
                <CardTitleSkeleton />
            ) : (
                <Box>
                    <Text fontWeight={700} fontSize={'20px'} mb={'4px'}>
                        {title}
                    </Text>

                    {isWarning && <WarningTagComp label={warningLabel} />}
                </Box>
            )}
            <Divider my={'24px'} />

            {children}
        </Box>
    );
};
